import { IDropdownOption } from "@fluentui/react";
import { useState } from "react";
import { useToast } from "../../toasts/ToastProvider";
import { IDataResult, ResponseStatus } from "../../common/models/Result";
import { DataUtils } from "../../common/views/DataUtils";
import { AddCartItemModel, CartInfo, EditCartItemModel } from "../models/CartModel";
import { CartItemService, CartService } from "../services/CartService";

export default function useCartVM(cartId: number) {
    const { showToast } = useToast();
    const service = new CartService();
    const itemService = new CartItemService();

    const [cart, setCart] = useState<CartInfo | undefined>(undefined);
    const [qtyOptions, setQtyOptions] = useState<IDropdownOption[]>([]);
    const [loading, setLoading] = useState(false);

    const onLoad = () => {
        console.log("cart loaded");
        get();
        setQtyOptions(getOptions());
    }

    const get = () => {
        const onResult = (result: IDataResult) => {
            const cart = result.data as CartInfo;
            setCart(cart);
        }

        setCart(undefined);

        const request = service.get(cartId, "", "0");
        DataUtils.onRequest(request, onResult);
    }

    const add = (productId: number, qty: number) => {
        if (cartId < 0) {
            get();
            return;
        }

        const model: AddCartItemModel = {
            cartId: cartId,
            productId: productId,
            qty: qty
        };

        const onResult = (result: IDataResult) => {
            if (result.status !== ResponseStatus.fail) {
                showToast(result.summaryText + " Toast" ?? "No Description");
                get();
            }
        }

        const request = itemService.add(model);
        DataUtils.onRequest(request, onResult);
    }

    const edit = (model: EditCartItemModel) => {
        setLoading(true);

        const onResult = (result: IDataResult) => {
            setLoading(false);

            if (result.status !== ResponseStatus.fail) {
                get();
            }
        }

        const request = itemService.edit(cartId, model);
        DataUtils.onRequest(request, onResult);
    }

    const del = (id: number) => {
        setLoading(true);

        const onResult = (result: IDataResult) => {
            setLoading(false);

            if (result.status !== ResponseStatus.fail) {
                get();
            }
        }

        const request = itemService.delete(id, cartId);
        DataUtils.onRequest(request, onResult);
    }

    const getOptions = () => {
        var options = [];

        for (let i = 0; i <= 20; i++) {
            options.push({ key: i, text: i.toString() });
        }

        return options;
    }

    const getTotal = () => {
        if (!cart) return 0;

        return cart.items.reduce((sum, item) => sum + (item.product.salePrice * item.qty), 0);
    }

    return {
        cartId,
        cart,
        qtyOptions,
        loading,

        onLoad,
        get,

        add,
        edit,
        del,

        getTotal
    }
}